/* eslint-disable @typescript-eslint/no-explicit-any */
import AmericanExpress from '@common/assets/images/payment-method-american-express-grey-icon.svg';
import ApplePay from '@common/assets/images/payment-method-apple-pay-grey-icon.svg';
import GooglePay from '@common/assets/images/payment-method-google-pay-grey-icon.svg';
import MasterCard from '@common/assets/images/payment-method-master-card-grey-icon.svg';
import Visa from '@common/assets/images/payment-method-visa-grey-icon.svg';
import { THEME } from '@common/constants/theme.constant';
import { getNow } from '@common/utils/get-now/now.util';
import React, { useMemo } from 'react';
import { css } from 'twin.macro';

export const RegisterFooter = (): JSX.Element => {
    const cardSrcList = useMemo((): string[] => [ApplePay, GooglePay, MasterCard, AmericanExpress, Visa], []);
    const isCookieControlAvailable = (): boolean => {
        return (window as any)?.CookieControl !== undefined;
    };
    return (
        <div css={styles.root}>
            <div css={styles.text}>© {getNow().getFullYear()} Oddbox Delivery Ltd. Registered in England No. 9638976. {isCookieControlAvailable() ? <span tw='underline cursor-pointer' onClick={(window as any)?.CookieControl.open}>Manage Cookies</span> : null}</div>
            <div css={styles.icons}>
                {cardSrcList.map((cardSrc) => (
                    <img src={cardSrc} css={styles.image} key={cardSrc} />
                ))}
            </div>
        </div>
    );
};
const maxWidth = '810px';
const styles = {
    root: css`
        display: flex;
        align-items: center;
        background-color: ${THEME.WHITE};
        color: ${THEME.BLACK};
        padding: 16px 40px;
        border-top: 1px solid ${THEME.GRAY_100};
        @media (max-width: ${maxWidth}) {
            flex-direction: column;
            align-items: center;
            text-align: center;
        }
    `,
    text: css`
        flex: 1;
        font-weight: 300;
        font-size: 14px;
        @media (max-width: ${maxWidth}) {
            order: 2;
            margin-top: 16px;
        }
    `,
    icons: css`
        display: flex;
        justify-content: flex-end;
        @media (max-width: ${maxWidth}) {
            flex-direction: row;
            justify-content: center;
            order: 1;
        }
    `,
    image: css`
        width: 50px;
        height: 34px;
        border: 1px solid ${THEME.GRAY_300};
        border-radius: 4px;
        padding: 3px 6px;
        margin-right: 12px;
        @media (max-width: ${maxWidth}) {
            width: 37.5px;
            height: 25.5px;
            margin-right: 9px;
        }
        :last-child {
            margin-right: 0;
        }
    `,
};
